export const environment = {
    production: false,
    baseUrl: "https://api.dev.eprimerx.com/primerxcloud/api/",
    //baseUrl: "http://localhost:8787/api/",
    reportWriterbaseUrl: "https://reportwriter.dev.eprimerx.com/api/",
    //reportWriterbaseUrl: "https://localhost:7090/api/",
    //formsbaseUrl: "https://localhost:7075/api/",
    formsbaseUrl: "https://forms.dev.eprimerx.com/api/",
    ePrimeRxSignalRUrl: "https://devprimerxcloud-signalr-webapp.azurewebsites.net/message",
    //ePrimeRxSignalRUrl: "https://localhost:5001/message",
    interfaceHubUrl: "https://interfacehubapi.dev.eprimerx.com/api/",
    documentBaseurl:"https://primeclouddocuments.dev.eprimerx.com/api/",
    priorAuthBaseUrl:"https://priorauth.dev.eprimerx.com/",
    prescriptionBaseUrl:"https://prescription.dev.eprimerx.com/api/",
    ivrBaseUrl:"https://api.dev.eprimerx.com/ivrservice/api/",
    //ivrBaseUrl:"https://localhost:44309/api/",
    //baseUrl: "http://52.170.238.175/api/",
    //baseUrl: "http://stage.eprimerx.com/api/",
    //baseUrl: "http://stage.eprimerx.com/api/",
    //baseUrl: "http://20.185.98.80:8787/api/",
    //baseUrl: "https://api.eprimerx.com/api/",
    // baseUrl: "https://preprod-api.eprimerx.com/api/",
    // baseUrl: "https://primerxcloud.qa.eprimerx.com/primerxcloud/api/",
    logoUrl: "",
    version: "#Version",
    ImageUrl: "http://localhost:4200/assets/dist/",
    baseUrlTranslations: "/",
    translationURL: "./assets/i18n/",
    DrugImage:
        "https://eprimerxuat.blob.core.windows.net/mms-drug-images-dev/{imagefile}",
    // PharmacyLogo:
    //     "https://eprimerxuat.blob.core.windows.net/mms-pharmacy-logo-uat/{tenantId}/{logofile}",
    PharmacyLogo:
    "https://eprimerx.blob.core.windows.net/mms-pharmacy-logo-devphase1/{tenantId}/{logofile}",
    SentryURL: "",
    SentryEnvironment: "",
    NDCBarcodeImageUrl:
        "https://eprimerx.blob.core.windows.net/mms-drug-images-stage/NDCBarcode.png",
    QRCodeImageUrl: 
        "https://eprimerx.blob.core.windows.net/mms-drug-images-stage/QRCode.png",
    RxBarcodeImageUrl:
        "https://eprimerx.blob.core.windows.net/mms-drug-images-stage/RxBarcode.png",
    RxRefFillBarcodeImageUrl:
    "https://eprimerx.blob.core.windows.net/mms-drug-images-stage/RxRefillFillBarcode.png",
        DrugBarcodeImageUrl:
        "https://eprimerx.blob.core.windows.net/mms-drug-images-stage/DrugImageSample.png",
    FiledRxImageUrl:
        "https://eprimerx.blob.core.windows.net/mms-drug-images-qa/Label-Filed.png",
    POSBarcodeImageUrl:"https://eprimerx.blob.core.windows.net/mms-drug-images-stage/POSBarcode.png",
    //DWTInstallFolder: "https://eprimerx.blob.core.windows.net/mms-drug-images-stage/DWTScanner",
    DWTInstallFolder: "https://eprimerx.blob.core.windows.net/mms-drug-images-stage/DWTScanner19.3.1",
    QzDownloadLink: "https://eprimerx.blob.core.windows.net/mms-drug-images-stage/qz-tray-2.2.2+1-x86_64.exe",
    QzDownloadLinkForMac: "https://eprimerx.blob.core.windows.net/mms-drug-images-stage/qz-tray-2.2.2-x86_64.pkg",
    JavaDownloadLink: "https://eprimerx.blob.core.windows.net/mms-drug-images-qa/openlogic-openjdk-11.0.16+8-windows-x64.msi",

    JavaDownloadLinkforMac: "https://eprimerx.blob.core.windows.net/mms-drug-images-qa/openlogic-openjdk-11.0.16+8-mac-x64.pkg",
    ControlFax: "https://eprimerx.blob.core.windows.net/mms-drug-images-stage/ControlFax.pdf",
    SingleFax: "https://eprimerx.blob.core.windows.net/mms-drug-images-stage/SingleFaxFormat.pdf",
    TransmissionRejNoCMS: "https://eprimerx.blob.core.windows.net/mms-drug-images-stage/TransmissionRejectedFax.pdf",
    TransmissionRejWithCMS: "https://eprimerx.blob.core.windows.net/mms-drug-images-stage/TransmissionRejectedFaxWithCMSForm.pdf",
    MultiFaxSingleFormat: "https://eprimerx.blob.core.windows.net/mms-drug-images-stage/MultipleFaxSingleRxFormat.pdf",
    MultiPageMultiFaxFormat: "https://eprimerx.blob.core.windows.net/mms-drug-images-stage/MutiplePageMultipleFaxFormat.pdf",
    GoogleAnalyticsKey: "",
    FONTAWESOME_NPM_AUTH_TOKEN: "",
    isReleaseNotes : true,
    isGeneratorFIle : true,
    isHoa : true,
    isTimeOffSet : false,
    isReportWriter: true,
    isClinicalForm: true,
    ipAddressUrl : "https://api64.ipify.org?format=json",
    IseRxTransferRequest: true,
    TransferInRequest: true,
    isProrAuth: true,
    // Secure Patient communication
    isSecurePatientComm: true,
    Negotiate_apiBaseUrl:'https://api.dev.eprimerx.com/primecomm',
    primecommproxy_BaseUrl:'https://primecommproxy.dev.eprimerx.com/',
    primecomm_BaseUrl:'https://primecomm.dev.eprimerx.com/',
    manualTransferout: true,
    transferoutResponse: true,
    isForImmunization : true,
    vaccinebaseurl : 'https://api.dev.eprimerx.com/',
    isPickUpEnabled: true,
    transferout: true,
    // Market Place
    isMarketPlace: true,
    isEnableNYErrors: true,
    isIvrEnabled: true,
    isMandateFieldsPickup: true,
    isCompReportEnabled: true,
    applyNewLoaderLogic: false,
    isPopupCenterAlignedDisable: true,
    datadogurl: "us3.datadoghq.com"
}

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import "zone.js/plugins/zone-error";  // Included with Angular CLI.